import {
  Table,
  TableBody,
  TableRow,
  TableCell,
  makeStyles,
  Theme,
  Tooltip,
} from '@material-ui/core';
import { formatCurrency } from '@roc/ui/utils';
import { Error } from '@material-ui/icons';

const useStyles = makeStyles((theme: Theme) => ({
  titleCell: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    borderBottom: '1px solid #E0E0E0',
    padding: theme.spacing(1.5, 2),
    fontWeight: 'bold',
  },
  labelCell: {
    width: '40%',
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    borderBottom: '1px solid #E0E0E0',
    padding: theme.spacing(1.5, 2),
  },
  valueCell: {
    fontSize: '0.875rem',
    color: theme.palette.text.primary,
    borderBottom: '1px solid #E0E0E0',
    padding: theme.spacing(1.5, 2),
  },
  matchCell: {
    fontSize: '0.875rem',
    color: theme.palette.text.primary,
    borderBottom: '1px solid #E0E0E0',
    padding: theme.spacing(1.5, 2),
    textAlign: 'center',
    width: '5%',
  },
  lastRow: {
    '& td': {
      borderBottom: 'none',
    },
  },
}));

export interface FundingTemplateItem {
  itemName: string;
  itemDisplayName: string;
  data: number | null;
  expectedData: number | null;
  needsRevisionFlag: boolean;
}

export interface HudFundingTemplateTableProps {
  items?: FundingTemplateItem[];
}

const formatAmount = (value: number | null) =>
  value === null || value === undefined ? '—' : formatCurrency(Number(value));

export const HudFundingTemplateTable = ({ items }: HudFundingTemplateTableProps) => {
  const classes = useStyles();
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <Table>
      <TableBody>
        <TableRow>
          <TableCell className={classes.matchCell} />
          <TableCell className={classes.titleCell}>Fee</TableCell>
          <TableCell className={classes.titleCell}>Portal</TableCell>
          <TableCell className={classes.titleCell}>Document</TableCell>
        </TableRow>
        {items.map((item, index) => (
          <TableRow
            key={item.itemName}
            className={index === items.length - 1 ? classes.lastRow : ''}
          >
            <TableCell className={classes.matchCell}>
              {item.needsRevisionFlag && (
                <Tooltip title="The extracted value does not match the loan's funding template.">
                  <Error color="error" />
                </Tooltip>
              )}
            </TableCell>
            <TableCell className={classes.labelCell}>{item.itemDisplayName}</TableCell>
            <TableCell className={classes.valueCell}>{formatAmount(item.expectedData)}</TableCell>
            <TableCell className={classes.valueCell}>{formatAmount(item.data)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
